import { render, staticRenderFns } from "./DatavMapVisitList.vue?vue&type=template&id=33a047c8&scoped=true&"
import script from "./DatavMapVisitList.vue?vue&type=script&lang=js&"
export * from "./DatavMapVisitList.vue?vue&type=script&lang=js&"
import style0 from "./DatavMapVisitList.vue?vue&type=style&index=0&id=33a047c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a047c8",
  null
  
)

component.options.__file = "DatavMapVisitList.vue"
export default component.exports